import {Record as record} from 'immutable';

import {resolve} from '../../helpers/LinkMapper';
import trainTime from '../../lib/TrainTime';

const defaults = {
    ticketId: null,
    cancellationDate: null,
    description: null,
    destinationCode: null,
    destinationName: null,
    externalIdentifierType: null,
    fare: null,
    fulfilmentType: null,
    initialPassCount: null,
    isExpired: null,
    nlc: null,
    orderId: null,
    originCode: null,
    originName: null,
    otrlTicketId: null,
    receivedDate: null,
    refundAmount: null,
    remainingPassCount: null,
    routeCode: null,
    routeName: null,
    saleType: null,
    ticketCategory: null,
    transitMode: null,
    validityEndDate: null,
    validityStartDate: null,
};

class TicketSmartCarnet extends record(defaults) {
    static fromJSON(json = {}) {
        return new TicketSmartCarnet({
            ticketId: resolve(json.ticketId).with(Number),
            cancellationDate: resolve(json.cancellationDate).with(trainTime),
            description: resolve(json.description).with(String),
            destinationCode: resolve(json.destinationCode).with(Number),
            destinationName: resolve(json.destinationName).with(String),
            externalIdentifierType: resolve(json.externalIdentifierType).with(String),
            fare: resolve(json.fare).with(Number),
            fulfilmentType: resolve(json.fulfilmentType).with(String),
            initialPassCount: resolve(json.initialPassCount).with(Number),
            isExpired: resolve(json.isExpired).with(Boolean),
            nlc: resolve(json.nlc).with(Number),
            orderId: resolve(json.orderId).with(String),
            originCode: resolve(json.originCode).with(Number),
            originName: resolve(json.originName).with(String),
            otrlTicketId: resolve(json.otrlTicketId).with(Number),
            receivedDate: resolve(json.receivedDate).with(trainTime),
            refundAmount: resolve(json.refundAmount).with(Number),
            remainingPassCount: resolve(json.remainingPassCount).with(Number),
            routeCode: resolve(json.routeCode).with(Number),
            routeName: resolve(json.routeName).with(String),
            saleType: resolve(json.saleType).with(String),
            ticketCategory: resolve(json.ticketCategory).with(String),
            transitMode: resolve(json.transitMode).with(String),
            validityEndDate: resolve(json.validityEndDate).with(trainTime),
            validityStartDate: resolve(json.validityStartDate).with(trainTime),
        });
    }
}

export default TicketSmartCarnet;



// WEBPACK FOOTER //
// ./src/records/smartCarnet/TicketSmartCarnet.js